module.exports = __webpack_public_path__ + "img/pb.5967a519.svg";